<template>
  <div class="extra-curricular pb-10">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Extra Curricular</h2>

             <UpgradeOption v-if="shouldShowUpgrade" @pressed="showUpgrade()">
        </UpgradeOption>
      </div>
    </header>

    <div
      class="header-subnav-holder">
      <button
        v-for="term in termDropdown"
        :key="term.key"
        type="button"
        class="header-subnav focus:outline-none"
        @click="termSelected = term"
        v-bind:class="[termSelected.key == term.key ? 'selected' : '']"
      >
        {{ term.name }}
      </button>
    </div>

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <Dropdown
            :options="typeDropdown"
            :selected="typeSelected"
            :title="'Activity Type'"
            v-on:updateOption="updateSelectedType"
            style="min-width: 10rem"
          ></Dropdown>
        </div>
      </template>

      <template v-slot:actions>
        <div>
          <button
            type="button"
            class="action-button hover:opacity-75  disabled:opacity-50 disabled:cursor-not-allowed"
            @click="addNew()"
              :disabled="shouldShowUpgrade"
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

    <div class="w-full overflow-x-hidden pb-24">
      <div v-if="errored" class="ml-10 mt-10 text-sm text-red-500">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Activities</p>
      </div>
      <template v-else>
        <!-- TABLE -->
        <table class="grid-content mx-auto " v-if="componentLoaded">
          <thead class="pt-4"> 
            <th></th>
            <!-- SET TABLE HEADINGS - DAYS -->
            <th
              v-for="day in days"
              v-bind:key="day"
              class="text-gray-400 uppercase font-semibold py-2"
            >
              {{ day }}
            </th>
          </thead>
          <tbody class="pb-10">
            <!-- SET SIDE HEADINGS - TIMEFRAME -->
            <tr
              v-for="time in timesframes"
              v-bind:key="time.title"
              class="h-48"
            >
              <td class="text-gray-500 text-right uppercase font-semibold w-6">
                <div class="transform -rotate-90 text-center">
                  {{ time.title }}
                </div>
              </td>
              <!-- Inline -->
              <td
                v-for="(day, index) in days"
                v-bind:key="index"
                class="
                  bg-white
                  rounded-xl
                  border-8 border-gray-100
                  m-2
                  w-44
                  align-top
                "
              >
                <div
                  class="group"
                  v-for="(activity, activity_index) in findActivities(
                    time,
                    day
                  )"
                  :key="activity_index"
                >
                  <button
                  @click="selectToShowMore(activity, activity_index, day)"
                    class="
                      w-full
                      h-12
                      bg-opacity-25
                      mb-1
                      rounded
                      text-xs
                      hover:bg-gray-200
                    "
                    v-bind:class="getBackgroundColor(activity)"
                  >
                    {{ activity.title }}
                  </button>
            <template>

              <transition
                enter-active-class="transition duration-300 ease-out transform"
                enter-class="-translate-y-3 scale-95 opacity-0"
                enter-to-class="translate-y-0 scale-100 opacity-100"
                leave-active-class="transition duration-150 ease-in transform"
                leave-class="translate-y-0 opacity-100"
                leave-to-class="-translate-y-3 opacity-0"
              >
                <div v-show="shouldShowMore(activity, activity_index, day)" class=" pt-2">
                  <div
                    class="
                      relative
                      py-1
                      bg-white
                      border border-gray-200
                      rounded-md
                      shadow-xl
                    "
                  >
                    <div
                      class="
                        absolute
                        top-0
                        w-4
                        h-4
                        origin-center
                        transform
                        rotate-45
                        translate-x-5
                        -translate-y-2
                        bg-white
                        border-t border-l border-gray-200
                        rounded-sm
                        pointer-events-none
              
                      "
                    ></div>
                    <div class="relative">
                      <a
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-gray-700
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                          cursor-pointer
                          border-b border-gray-200
                        "
                        @click="viewActivity(activity, day, time)"
                        >View</a
                      >
                      <a
                      @click="viewAttendanceSelection(activity, day, time)"
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-orange-500
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                          cursor-pointer
                          border-b border-gray-200
                        "
                        >Attendance</a
                      >
                      <a
                        @click="cancelMore()"
                        class="
                          block
                          w-full
                          px-4
                          py-2
                          font-medium
                          text-blue-500
                          whitespace-no-wrap
                          hover:bg-gray-100
                          focus:outline-none
                          hover:text-gray-900
                          focus:text-gray-900 focus:shadow-outline
                          transition
                          duration-300
                          ease-in-out
                          cursor-pointer
                        "
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </transition>
            </template>


                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="noResultsFound"
          class="ml-4 font-bold w-full cursor-pointer text-center"
          @click="addNew"
        >
          <p class="mt-10 text-gray-400 text-sm w-full text-center">
            No extra curricular activities found. Please select another month or
            click to add a new activity.
          </p>
        </div>
      </template>
    </div>

    <ModalSlide
      :show="showAttendanceGrid"
      @closeModal="closeAttendanceSelection"
    >
      <template v-slot:header-icon>
        <i class="fas fa-calendar-alt"></i>
      </template>
      <template v-slot:header-title>
        <div v-if="showAttendanceGrid">
          {{ attendanceTitle }}
          <div class="text-xs">{{ attendanceSubTitle }}</div>
        </div>
      </template>
      <template v-slot:body>
        <ActivityAttendance
          :attendanceCriteria="selectedAttendanceCriteria"
          @close="closeAttendanceSelection"
          @view="closeAttendanceSelectionAndView"
          v-if="showAttendanceGrid"
        ></ActivityAttendance>
      </template>
    </ModalSlide>

  
        <UpgradeModal
      v-if="showUpgradeModal"
      @close="showUpgrade()"
      :area="'Extra Curricular'"
    ></UpgradeModal>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ActivityService } from "@/services/activity.service";
import { termList, ecTypes, timesframes } from "../assets/js/utils";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";


const ActivityAttendance = () => import("@/components/ActivityAttendance.vue");
const ModalSlide = () => import("@/components/ModalSlide.vue");
const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const UpgradeOption = () => import("@/components/upgrade/UpgradeOption.vue");


import moment from "moment";
export default {
  name: "extra-curricular",
    mixins: [upgradeMixin],
  components: {
    Dropdown,
    ModalSlide,
    ActivityAttendance,
    FilterBar,
        UpgradeModal,
    UpgradeOption,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.activities.length > 0 && this.loading === false;
    },
    typeDropdown() {
      let results = [{ id: 0, name: "All Program Types" }].concat(this.types);
      if (this.typeSelected.id === undefined) {
        this.typeSelected = results[0];
      }
      return results;
    },
    termDropdown() {
      var results = this.terms;
      this.termSelected = results[0];
      return results;
    },
    noResultsFound() {
      return !this.errored && !this.componentLoaded;
    },
    attendanceTitle() {
      return this.selectedAttendanceCriteria.activity.title + " Attendance";
    },
    attendanceSubTitle() {
      return (
        this.selectedAttendanceCriteria.term.name +
        ", " +
        this.selectedAttendanceCriteria.day +
        " @ " +
        this.selectedAttendanceCriteria.time.title
      );
    },
  },
  data() {
    return {
      errored: false,
      loading: true,
      showSearch: false,
      search: "",
      termSelected: {},
      activities: [],
      days: [],
      timesframes: timesframes(),
      terms: termList(),

      types: ecTypes(),
      typeSelected: {},

      showOptionMenu: false,

      pupilsSelectedList: [],
      showAttendanceGrid: false,

      selectedAttendanceCriteria: {},

      selectedActivity: {},
      selectedIndex: 0,
      selectedDay: undefined,
    };
  },
  created() {
    moment.locale("en-gb");
    this.days = moment.weekdays(true);
    this.termSelected = this.terms[0];
    this.fetchActivities();
  },
  methods: {
    fetchActivities() {
      ActivityService.getAll()
        .then((response) => (this.activities = response.data.data))
        .catch((err) => {
          console.log("Activities " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getBackgroundColor(activity) {
      let type = this.getProgramType(activity);
      return type != undefined ? type.class : "bg-red-200";
    },
    getProgramType(activity) {
      return this.types.find((t) => t.value === activity.session_type);
    },
    updateSelectedTerm(term) {
      this.termSelected = term;
    },
    updateSelectedType(type) {
      this.typeSelected = type;
    },
    setStyles(term) {
      return this.termSelected.key === term.key
        ? "bg-blue-300 text-white hover:bg-blue-200"
        : "bg-blue-200 text-blue-400 hover:bg-blue-300 ";
    },
    setListStyle() {
      return "rounded bg-" + this.currentUser.schoolBackground;
    },
    setSearch() {
      this.showSearch = !this.showSearch;
      this.search = "";
    },
    selectToShowMore(activity, index, day) {
      this.selectedActivity = activity;
      this.selectedIndex = index
      this.selectedDay = day

    },
    shouldShowMore(activity, index, day) {
      // console.log(JSON.stringify(activity))
      // console.log(this.selectedDay)
      return (this.selectedActivity.identifier === activity.identifier &&
                  this.selectedIndex === index && 
                  this.selectedDay.toLowerCase() === day.toLowerCase())
    },
    cancelMore() {
      this.selectedActivity = {}
      this.selectedIndex = 0
    },
    findActivities(time, day) {
      let vm = this;
      let termData = vm.activities
        .filter(function (obj) {
          return obj.term === vm.termSelected.key;
        })
        .flatMap(function (obj) {
          return obj.data;
        });

      let dayData = termData
        .filter(function (obj) {
          return obj.weekday.toLowerCase() === day.toLowerCase();
        })
        .flatMap(function (obj) {
          return obj.weekday_data;
        });

      var filteredList = dayData.filter((item) => {
        var filtered = true
        if (this.typeSelected.id > 0) {
          if (this.typeSelected.value === 'education') {
            filtered = ['physical', 'education'].includes(item.session_type)
          } else {
            filtered = item.session_type === this.typeSelected.value
          }
        }

        if (filtered) {
          filtered = item.title.toLowerCase().includes(vm.search.toLowerCase())
        }

        return filtered
      });

      let arr = _.filter(filteredList, function (a) {
        const times = a.timeframe.split(",");

        return times.includes(time.time_value);
      });

      return arr;
    },
    addNew() {
      let activity = {};
      this.$router.push({
        name: "ActivityView",
        params: { activity: activity, newAddition: true },
      });
    },
    viewAttendanceSelection(activity, day, time) {
      this.showAttendanceGrid = true;
      this.selectedAttendanceCriteria = {
        activity: activity,
        term: this.termSelected,
        day: day,
        time: time,
      };
    },
    viewActivity(activity) {
      this.$router.push({
        name: "ActivityView",
        params: { activity: activity, newAddition: false },
      });
    },
    closeAttendanceSelection() {
      this.showAttendanceGrid = false;
      this.selectedAttendanceCriteria = {};
    },
    closeAttendanceSelectionAndView() {
      let activity = this.selectedAttendanceCriteria.activity;
      this.closeAttendanceSelection();
      this.viewActivity(activity);
    },
    setSearchValue(value, time = 300) {
      this.search = value;
    },
  },
};
</script>

